import { atom, selector } from "recoil";
import { POTEKA_TYPE_AIR_TEMP } from "../components/map/layers/Poteka";
import { getCustomerSettings } from "../CustomerSettings";

export const potekaElementState = atom({
  key: 'potekaElementState',
  default: selector({
    key: 'potekaElement',
    get: () => {
      const element = getCustomerSettings("layerConfig.WX_ID_POTEKA.defaultElement");
      return element ? element : POTEKA_TYPE_AIR_TEMP;
    }
  })
});
